module.exports = __webpack_public_path__ + "static/media/IMG_7861.ce165e07.JPG";